//import Model from "~/models/eschoolplus/registration/Student";
import Model from "~/models/_Model";

export default class SystemMeta extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/leydenmobile";
  }

  // Set the resource route of the model
  resource() {
    return "metadata";
  }

  relations() {
    return {
      //student: Student,
    };
  }

  /**
   * Helper Methods
   */

  /**
   * Helper Attributes
   */
}
